module.exports = __webpack_public_path__ + "static/media/14.13b58999.jpg";